// extracted by mini-css-extract-plugin
export default {"seperator":"Accordion_seperator__6iPo8"};